export enum FileMimeTypesEnum {
    Pdf = 'application/pdf',
    Png = 'image/png',
    Jpg = 'image/jpg',
    Jpeg = 'image/jpeg',
    PlainText = 'text/plain'
}
